import {
  getPlanningInThePastRoleDefaultsRequest,
  parseContractComplianceError,
} from 'api/requests/contract-compliance-requests';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CONTRACT_COMPLIANCE__LOAD_ERROR } from 'translations/constants';
import { IPlanningInThePastEntry } from 'types/contract-compliance/IContractCompliance';
import { getContractComplianceErrorMessage } from '../../utils';

/** The role defaults (a fixed short list: no search, no paging). Only the latest answer is applied. */
export const usePlanningInThePastDefaults = () => {
  const [t] = useTranslation();
  const [defaults, setDefaults] = useState<IPlanningInThePastEntry[]>([]);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [loadErrorMessage, setLoadErrorMessage] = useState<string | null>(null);
  const latestRequest = useRef(0);

  const reload = useCallback(async () => {
    latestRequest.current += 1;
    const requestId = latestRequest.current;
    try {
      const values = await getPlanningInThePastRoleDefaultsRequest();
      if (requestId !== latestRequest.current) return;
      setDefaults(values);
      setLoadErrorMessage(null);
      setHasLoaded(true);
    } catch (error) {
      if (requestId !== latestRequest.current) return;
      setLoadErrorMessage(
        getContractComplianceErrorMessage(t, parseContractComplianceError(error), CONTRACT_COMPLIANCE__LOAD_ERROR),
      );
    }
  }, [t]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { defaults, hasLoaded, loadErrorMessage, reload };
};

export type UsePlanningInThePastDefaultsResult = ReturnType<typeof usePlanningInThePastDefaults>;
